<template>
  <div class="form-group">
    <label :for="id" class="form-label">
      {{ label }} 
      <span v-if="required" class="required-mark">*</span>
    </label>
    <div class="input-wrapper">
      <input 
        :type="type" 
        class="form-input" 
        :id="id" 
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        @focus="isFocused = true"
        @blur="isFocused = false"
        :required="required"
        :placeholder="placeholder"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    modelValue: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isFocused: false
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  letter-spacing: -0.01em;
}

.required-mark {
  color: #ef4444;
  margin-left: 2px;
}

.input-wrapper {
  position: relative;
}

.form-input {
  width: 100%;
  padding: 14px 16px;
  font-size: 1rem;
  color: #1a1f3a;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;
  font-family: inherit;
}

.form-input::placeholder {
  color: #9ca3af;
}

.form-input:hover {
  border-color: #d1d5db;
  background: #ffffff;
}

.form-input:focus {
  background: #ffffff;
  border-color: #2a5298;
  box-shadow: 0 0 0 4px rgba(42, 82, 152, 0.1);
}
</style>

